import { render, staticRenderFns } from "./CTASupportElement.vue?vue&type=template&id=490a090c&scoped=true&"
import script from "./CTASupportElement.vue?vue&type=script&lang=js&"
export * from "./CTASupportElement.vue?vue&type=script&lang=js&"
import style0 from "./CTASupportElement.vue?vue&type=style&index=0&id=490a090c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a090c",
  null
  
)

export default component.exports